import axios from "axios";
import AxiosClient from "../../../services/axios.services";

class ModalitiesServices {
  getModalities = params =>
    AxiosClient.get("/api/app/capacitacion_modalidad/", {
      headers: { "Content-Type": "application/json" },
      params: params,
   });
  getModality = id =>
    AxiosClient.get(`/api/app/capacitacion_modalidad/${id}/`, {
      headers: { "Content-Type": "application/json" },
    });
  saveModalities = data =>
    AxiosClient.post("/api/app/capacitacion_modalidad/", data, {
      headers: { "Content-Type": "application/json" },
    });
  editModalities = (id, data) =>
    AxiosClient.put(
      `/api/app/capacitacion_modalidad/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  deleteModalities = id =>
    AxiosClient.delete(`/api/app/capacitacion_modalidad/${id}`, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new ModalitiesServices();